
const ScrollToScheduler = () => {
    var scrollTarget = document.getElementById("scheduleATour");
    if (scrollTarget != null) {
        scrollTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
        });
    }
}


$(document).ready(function () {
    $("#BookATourNavCallout1").on("click", function () {
        ScrollToScheduler();
    });
    $("#BookATourNavCallout2").on("click", function () {
        ScrollToScheduler();
    });

});